import { createWebHistory, createRouter } from 'vue-router'
import LoginView from "../components/LoginView.vue";
import CalendarView from "../components/CalendarView.vue";

import { auth } from "../plugins/firebase/index";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    component: LoginView,
    name: "login",
    meta: {
      requiresAuth: false,
    }, 
  },
  {
    path: "/login/:token",
    component: LoginView,
    name: "loginWithToken",
    meta: {
      requiresAuth: false,
    }, 
  },
  {
    path: "/calendar",
    name: "calendar",
    component: CalendarView,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// checks auth
router.beforeEach(async (to, from, next) => {
  const currentUser = await auth?.currentUser?.getIdTokenResult();
  const getIdTokenResult = currentUser ? currentUser : false
  const isUser = getIdTokenResult ? (getIdTokenResult?.claims?.user == "true") : false
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);


  if ((to.name === 'login' || to.name === 'NotAllowed') && currentUser && isUser) next({ name: 'calendar' })
  else if (requiresAuth && currentUser && isUser) next();
  else if (to.name != 'login' && requiresAuth && !currentUser || to.name != 'login' && requiresAuth && !isUser) next({ name: "login" });
  else next();
  
});
export default router;
